import dayjs from "dayjs";
import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import {
  BulkConfirmRequest,
  BulkConfirmResult,
  RecoveryMailRequest,
  RecoveryMailResult,
  UnconfirmedUsersSummary,
} from "./type";

export const DEFAULT_LOOKBACK_DAYS = 14;

export const defaultSince = () => dayjs().subtract(DEFAULT_LOOKBACK_DAYS, "day").startOf("day");

export const unconfirmedUsersLoader: LoaderFunction = async (args) => {
  const url = new URL(args.request.url);
  const since = url.searchParams.get("since") || defaultSince().toISOString();
  const result = await axiosApi.get<Result<UnconfirmedUsersSummary>>(
    `/api/users/unconfirmed?since=${encodeURIComponent(since)}`
  );
  return result.data;
};

export const queueRecoveryMail = (dto: RecoveryMailRequest) =>
  axiosApi.post<Result<RecoveryMailResult>>("/api/users/unconfirmed/recovery-mail", dto);

export const confirmUnconfirmed = (dto: BulkConfirmRequest) =>
  axiosApi.post<Result<BulkConfirmResult>>("/api/users/unconfirmed/confirm", dto);
